import DOMGL_OBJ from './class/class-dom-obj.js';
import DOMGL from './class/class-dom.js';
// import BGGL from './class/class-bg.js';


/*
==============================

概要
1. ページ内のDOMを取得
2. 事前にRESOURCEに登録されている DOMGL を呼び出し、取得されたDOMとpost_idを介して連携
3. 連携内容は マウスイベント や リサイズ や inview

==============================
*/


WEBGL.dom = {

	local : null,
	ready : false,
	items : {},
	keys  : [],

	onInit( elem ){

		//
		this.local = !elem ? document : elem;
		const $el = this.local.querySelectorAll('.js-gl');

		//
		for (let i = 0; i < $el.length; i++) {

			//
			let el = $el[i];
			let targetElement = $el[i].querySelector('.js-gl-target');
			let dataElement   = $el[i].querySelector('.js-gl-data') ? $el[i].querySelector('.js-gl-data') : el;
			let mouseElement  = $el[i].querySelector('.js-gl-mouse') ? $el[i].querySelector('.js-gl-mouse') : el;
			let rect = targetElement.getBoundingClientRect();
			let autoplay = dataElement.dataset.autoplay ? Boolean( dataElement.dataset.autoplay ) : false;
			let alpha = dataElement.dataset.alpha ? Number( dataElement.dataset.alpha ) : 1;

			//
			let key    = dataElement.dataset.key;
			let name   = dataElement.dataset.name;
			let type   = dataElement.dataset.type;
			let postId = dataElement.dataset.postId;
			let cloneKey  = dataElement.dataset.cloneKey || false;
			let observer = new IntersectionObserver( this.listerner, { threshold: 0 });
			observer.observe( el );

			//
			let gl = null;
			switch( type ){
				case 'prelaod':
					if( RESOURCE.items[ key ] ){
						gl = RESOURCE.items[ key ].gl;
						gl.autoplay = autoplay;
						gl.alpha = alpha;
						gl.onUpdateProp();
					}
				break;
				case 'dom':
					gl = new DOMGL( new DOMGL_OBJ( dataElement.dataset, 'white' ) );
					gl.autoplay = autoplay;
					gl.alpha = alpha;
					gl.onUpdateProp();
				break;
			}

			//
			this.items[ key ] = {
				gl       : gl,
				key      : key,
				name     : name,
				type     : type,
				postId   : postId,
				cloneKey : cloneKey,
				el       : el,
				targetElement : targetElement,
				mouseElement : mouseElement,
				min      : false,
				max      : false,
				events   : {
					click      : null,
					mouseleave : null,
					mouseenter : null,
				},
				rect     : { x : rect.left, y : rect.top, width : rect.width, height : rect.height },
				observer : observer,
				visible  : false,
				shown    : false
			}
			this.keys.push( key );

		}

		this.addEvents();

		this.ready = true;

	},

	onReInit(){
		this.onDestroy();
		this.onInit();
	},

	addEvents(){
		console.log('WEBGL.dom.addEvents();');
		for (let i = 0; i < this.keys.length; i++) {
			const key = this.keys[i];
			const v = this.items[key];
			if( key != 'about' && !v.autoplay ){
				v.events.mouseleave = () =>{
					if( v.gl ) v.gl.onMouseLeave();
				}
				v.events.mouseenter = () =>{
					if( v.gl ) v.gl.onMouseEnter();
				}
				document.addEventListener('mouseleave',v.events.mouseleave);
				v.mouseElement.addEventListener('mouseleave',v.events.mouseleave);
				v.mouseElement.addEventListener('mouseenter',v.events.mouseenter);
			}

		}
	},

	removeEvents(){
		for (let i = 0; i < this.keys.length; i++) {
			const key = this.keys[i];
			const v = this.items[key];
			if( v.events.mouseleave ){
				document.removeEventListener('mouseleave',v.events.mouseleave);
				v.mouseElement.removeEventListener('mouseleave',v.events.mouseleave);				
				v.events.mouseleave = null;
			}
			if( v.events.mouseenter ){
				v.mouseElement.removeEventListener('mouseenter',v.events.mouseenter);
				v.events.mouseenter = null;
			}
		}
	},

	onDestroy(){

		//
		this.ready = false;
		this.removeEvents();

		//
		for (let i = 0; i < this.keys.length; i++) {
			const key = this.keys[i];
			const v = this.items[key];
			if( v ){
				v.observer.disconnect( v.el );
				v.observer = null;
				if( v.gl ){
					v.gl.onReset();
					if( v.type === 'dom' ){
						v.gl.onDestroy();
						v.gl = null;
					}
				}
			}
		}

		//
		this.items = {};
		this.keys  = [];

	},

	listerner(changes) {
		changes.forEach((e, i) => {
			const el = e.target;
			const isIntersecting = e.isIntersecting;
			if ( isIntersecting ) {
				el.dataset.shown   = 1;
				el.dataset.visible = 1;
			} else {
				el.dataset.visible = 0;
			}
		});
	},

	onPreRender(){
		for (let i = 0; i < this.keys.length; i++) {
			const key = this.keys[i];
			const v = this.items[key];
			if( v.gl ){
				const rect = v.targetElement.getBoundingClientRect();
				v.rect.width = rect.width;
				v.rect.height = rect.height;
				v.rect.x = rect.left;
				v.rect.y = rect.top;
				v.gl.shown   = true;
				v.gl.visible = true;
				v.gl.onUpdate( v.rect );
				if( v.type === 'dom' && v.name === 'member' ){
					v.gl.onRender({
						shown   : true,
						visible : true
					});
				} else if( v.type === 'dom' && v.name === 'slider' ){
					v.gl.onScroll( v.rect );
					v.gl.onRender({
						shown   : true,
						visible : true
					});
				} else {
					v.gl.onRender({
						shown   : true,
						visible : true
					});
				}

			}
		}
	},


	onUpdate(){
		for (let i = 0; i < this.keys.length; i++) {
			const key = this.keys[i];
			const v = this.items[key];
			if( v ){
				const rect = v.targetElement.getBoundingClientRect();
				const buffer = WH * 0.33;
				v.min = rect.top <= WH + buffer;
				v.max = rect.top > -rect.height - buffer;
				v.shown   = ( Number( v.el.dataset.shown ) === 1 ) || ( v.min && v.max );
				v.visible = ( Number( v.el.dataset.visible ) === 1 ) || ( v.min && v.max );
				// v.shown   = ( Number( v.el.dataset.shown ) === 1 );
				// v.visible = ( Number( v.el.dataset.visible ) === 1 );
				if( v.visible ){
					if( v.rect.width != rect.width || v.rect.y != rect.top ){
						v.rect.width = rect.width;
						v.rect.height = rect.height;
						v.rect.x = rect.left;
						v.rect.y = rect.top;
					}
					if( v.gl ){
						v.gl.onUpdate( v.rect );
					}
				}
			}
		}
	},

	onRender(){

		// let domVisible = 0;

		let visibleGl = 'none';

		for (let i = 0; i < this.keys.length; i++) {
			const key = this.keys[i];
			const v = this.items[key];
			// v.shown   = ( Number( v.el.dataset.shown ) === 1 );
			// v.visible = ( Number( v.el.dataset.visible ) === 1 );
			if( v.gl ){

				if( v.visible ) visibleGl = v.name;

				if( v.type === 'dom' && v.name === 'member' ){

					const cx = ( styleMouse.body.array[1].delta.x - v.rect.x - v.rect.width/2 ) / WW;
					const cy = ( styleMouse.body.array[1].delta.y - v.rect.y - v.rect.height/2 ) / WH;
					const x  = cx * window.innerWidth  * 0.5;
					const y  = cy * window.innerHeight * 0.5;
					v.gl.onMouseMove( x, y );
					v.gl.onRender({
						shown   : v.shown,
						visible : ( v.visible && v.gl.onmouse )
					});

				} else if( v.type === 'dom' && v.name === 'slider' ){

					if( v.visible ){
						const rect = v.targetElement.getBoundingClientRect();
						v.rect.x = rect.left;
						v.rect.y = rect.top;
						v.gl.onScroll( v.rect );
					}

					v.gl.onRender({
						shown   : v.shown,
						visible : v.visible
					});

				} else {

					v.gl.onRender({
						shown   : v.shown,
						visible : v.visible
					});

				}

			}
		}
		$html.dataset.visibleGl = visibleGl;

	},


	onScroll(){
		for (let i = 0; i < this.keys.length; i++) {
			const key = this.keys[i];
			const v = this.items[key];
			if( v ){
				if( v.visible ){
					const rect = v.targetElement.getBoundingClientRect();
					v.rect.x = rect.left;
					v.rect.y = rect.top;
					if( v.gl ) v.gl.onScroll( v.rect );
				}
			}
		}
	},

}





















